// extracted by mini-css-extract-plugin
export default {"title":"styles_title__wM+ka","container":"styles_container__Yr-42","titleText":"styles_titleText__mje-U","buttonSubscribe":"styles_buttonSubscribe__y-joM"};